import { UseTellescopeQueryOptions } from "../../types";
import { useTellescopeQuery } from "../../use-tellescope-query";

export interface TwilioPhoneNumber {
  phoneNumber: string;
  sid: string;
  friendlyName: string;
  type: "TFN" | "10DLC";
  capabilities: {
    voice: boolean;
    sms: boolean;
    mms: boolean;
  };
  isInMessagingService: boolean;
  messagingServiceSid?: string;
  tfnVerificationStatus?:
    | "verified"
    | "pending"
    | "in_review"
    | "rejected"
    | "not_started"
    | "not_required"
    | "unknown";
  bundleSid?: string;
  bundleStatus?: string;
}

export interface TwilioActionsResponse {
  data: {
    availableActions: string[];
    phoneNumbers: TwilioPhoneNumber[];
    businessProfileStatus: {
      status: "not_started" | "draft" | "pending" | "in_review" | "approved" | "rejected";
      friendlyName?: string;
    };
  };
}

export interface UseTwilioActionsQueryOptions<TError = Error, TData = TwilioActionsResponse>
  extends Omit<
    UseTellescopeQueryOptions<"integrations", "proxy_read", TError, TData>,
    "model" | "method" | "request"
  > {}

export const useTwilioActionsQuery = <TError = Error, TData = TwilioActionsResponse>(
  options: UseTwilioActionsQueryOptions<TError, TData> = {}
) =>
  useTellescopeQuery({
    model: "integrations",
    method: "proxy_read",
    request: {
      integration: "Twilio",
      type: "actions",
    },
    ...options,
  });
